<div class="ticket-comment">
  <a
    class="back-link icon-text block md:hidden"
    [routerLink]="['/tickets', ticket.Id]"
  >
    <div class="custom-icon arrow_back"></div>
    Back to Ticket Detail
  </a>

  @if (
    !ticket.IsClosed &&
    ticket.Business_Purpose__c !== BusinessPurpose.NOCProactiveCustomerAlert
  ) {
    <div
      class="post-container w-full"
      *ngxPermissionsOnly="Permission.TICKETING_WRITE"
      [ngClass]="{ 'sticky-comment-header': browserSize !== 'small' }"
    >
      @if (isCommentSubmitting) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      } @else {
        @if (!isCommentEmpty) {
          @if (hasError) {
            <p class="comment-warning error">
              Your comment could not be submitted. Please try again.
            </p>
          } @else {
            <p class="comment-warning">
              You have not submitted your comment! Click 'Send' to submit.
            </p>
          }
        }
      }
      <form
        class="post-comment"
        (ngSubmit)="!isCommentSubmitting ? saveFormComment(commentForm) : ''"
        [formGroup]="commentForm"
      >
        <div
          class="comment-form flex w-full py-2"
          (mouseleave)="onCommentChanges(commentText.value)"
        >
          <mat-form-field hideRequiredMarker="true">
            <textarea
              matInput
              formControlName="Body__c"
              placeholder="POST A COMMENT"
              required
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="7"
              spellcheck="true"
              #commentText
              (input)="onCommentChanges(commentText.value)"
            ></textarea>
          </mat-form-field>
        </div>
        <button
          class="btn-primary"
          type="submit"
          [disabled]="!commentForm.valid || isCommentSubmitting"
        >
          Send
        </button>
      </form>
    </div>
  }

  @if (ticket?.Comments__r?.records?.length) {
    <div
      class="list-comments"
      [ngClass]="{
        expand: viewMoreComments,
        collapse: !viewMoreComments && browserSize !== 'small',
      }"
      #commentsContainer
    >
      <div class="comment-container-outer">
        @for (comment of ticket.Comments__r.records; track comment.Id) {
          <div class="comment-container">
            <div class="details">
              <div class="createdby-photo">
                <span>
                  @if (comment?.Contact__r?.Name !== 'System User') {
                    <img
                      alt="logged in user icon"
                      src="assets/images/icons_legacy/img_user_default@2x.png"
                    />
                  } @else {
                    <img
                      alt="Comcast Business user icon"
                      src="assets/images/icons_legacy/img_user_nitel@2x.png"
                    />
                  }
                </span>
              </div>
              <div class="details-section">
                <div
                  class="divider"
                  [ngClass]="{ 'comment-new': !comment.Is_Read__c }"
                >
                  @if (!comment?.Is_Read__c) {
                    <span>New</span>
                  }
                </div>
                <div class="creation">
                  <!-- If comment creator is created by the user/contact, show user's fullname
            If comment is not created by contact or user, show Nite's employee's first name only -->
                  <div class="createdby">
                    @if (
                      comment?.Contact__r?.Name && !comment?.User__r?.FirstName
                    ) {
                      {{
                        comment.Contact__r.Name === 'System User'
                          ? 'Comcast Business'
                          : (comment.Contact__r.Name | titlecase)
                      }}
                    }
                    @if (
                      !comment?.User__r?.FirstName && !comment?.Contact__r?.Name
                    ) {
                      {{
                        comment?.CreatedBy?.FirstName === 'Api' ||
                        comment?.CreatedBy?.FirstName === 'API' ||
                        comment?.CreatedBy?.FirstName === 'My' ||
                        comment?.CreatedBy?.FirstName === 'Salesforce'
                          ? 'Comcast Business'
                          : (comment?.CreatedBy?.FirstName | titlecase)
                      }}
                    }
                    @if (
                      !comment?.Contact__r?.Name && comment?.User__r?.FirstName
                    ) {
                      {{
                        comment.User__r?.FirstName === 'System'
                          ? 'Comcast Business'
                          : (comment.User__r?.FirstName | titlecase)
                      }}
                    }
                  </div>
                  <div class="createddate">
                    {{ comment.CreatedDate | date: 'h:mma, MMM d, y' }}
                  </div>
                </div>
                <div class="comment-body" [innerHtml]="comment?.Body__c"></div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }

  <div class="hidden lg:block"></div>
</div>
